import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Homepage from './Pages/Homepage';
import Secondpage from './Pages/Secondpage';
import Profile from './Pages/Profile';
import Policy from './components/policy';
import FindPractitioners from './Pages/Find-practitioners';
import PractitionerList from './Pages/PractitionerList';
import ContactUs from './Pages/Contact';
import DoctorSignup from './Pages/DoctorSignup';
import ClinicSignup from './Pages/ClinicSignup';
import Payment from './components/Payment';
import ListYourself from './components/ListYourselfModal';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key
const stripePromise = loadStripe('pk_live_51MkDNUKx0rXRL6v7CPCCeukNvoyvRBJJC8igLsmC1wR3BN4qx9BrAZ6VnZiy7Hqg0E3m4jg0esk8qFejT5HMRN3h00CCt4iMlG');

function App() {
  return (
    <Elements stripe={stripePromise}>
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/practitioners" element={<Secondpage />} />
          <Route path="/find-practitioners" element={<FindPractitioners />} />
          <Route path="/practitioner-list" element={<PractitionerList />} />
          {/* <Route path="/list-yourself" element={<ListYourself />} /> */}
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/profile/:id" element={<Profile />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/doctor-signup" element={<DoctorSignup />} />
          <Route path="/clinic_register" element={<ClinicSignup />} />
          <Route path="/payment" element={<Payment />} />
        </Routes>
      </Router>
    </Elements>
  );
}

export default App;
